import React from 'react';
import {
  SkeletonContent,
  SkeletonBlock,
  SkeletonLine,
  Card
} from '@one-thd/sui-atomic-components';

const ProjectsDetailsBoxLoading = () => (
  <Card
    data-component="ProjectsDetailsBoxLoading"
    data-testid="projects-details-box-loading"
    className="@sm:sui-min-w-96 sui-w-full sui-h-full"
  >
    <div className="sui-flex sui-justify-between">
      <SkeletonContent disablePadding initialSize="1/4">
        <SkeletonBlock aspect="wide" height={4} />
      </SkeletonContent>
      <SkeletonContent disablePadding initialSize="1/4">
        <SkeletonBlock aspect="wide" height={4} />
      </SkeletonContent>
    </div>
    <SkeletonContent disablePadding className="sui-w-full">
        <SkeletonLine variant="multi" numberOfLines={2} />
    </SkeletonContent>
    <div className="sui-flex sui-gap-4 sui-w-3/5">
      <SkeletonBlock key={`skeleton-sq-0`} aspect="square" height={12} />
      <SkeletonBlock key={`skeleton-sq-1`} aspect="square" height={12} />
      <SkeletonBlock key={`skeleton-sq-2`} aspect="square" height={12} />
    </div>
  </Card>
);

export const ProjectsLoading = () => {
  return (
    <div
      data-component="ProjectsLoading"
      data-testid="projects-container-loading"
      className="sui-flex sui-flex-col sui-gap-4"
    >
      {/* Header Section */}
      <div className="sui-flex sui-justify-between">
        <SkeletonContent disablePadding initialSize="1/4">
          <SkeletonBlock aspect="wide" height={8} />
        </SkeletonContent>
        <SkeletonContent disablePadding initialSize="1/4">
          <SkeletonBlock aspect="wide" height={8} />
        </SkeletonContent>
      </div>

      <div className="
      sui-flex sui-flex-col @sm:sui-flex-row
      @sm:sui-flex-nowrap sui-gap-4 sui-w-full @sm:sui-overflow-auto"
      >
        {Array.from({ length: 4 }, (val, index) => (
          <div
            key={`project-skeleton-${index}`}
            className={index >= 3 ? 'sui-hidden @sm:sui-block' : ''}
          >
            <ProjectsDetailsBoxLoading />
          </div>
        ))}
      </div>

      <div className="@sm:sui-hidden sui-mt-8">
          <SkeletonBlock aspect="wide" height={11} />
      </div>
    </div>
  );
};
